    /**
     * 문자열이 빈 문자열인지 체크하여 결과값을 리턴한다.
     * @param str       : 체크할 문자열
     */
    export function isEmpty(str){

        if(typeof str == "undefined" || str == null || str == "")
            return true;
        else
            return false ;
    }

    /**
     * 문자열이 빈 문자열인지 체크하여 기본 문자열로 리턴한다.
     * @param str           : 체크할 문자열
     * @param defaultStr    : 문자열이 비어있을경우 리턴할 기본 문자열
     */
    export function nvl(str, defaultStr){

        if(typeof str == "undefined" || str == null || str == "")
            str = defaultStr ;

        return str ;
    }

    /**
     * 숫자에 콤마 삽입
    */ 
    //숫자에 콤마 찍기
function Numberchk(val) {
	let re = /^[+-]?\d*(\.?\d*)$/g; 
	let rs = re.test(val); 
	return rs; 
}
//onkeyup 시
export function vComma(obj) { 		
	if (!Numberchk(obj.value.replace(/,/gi,''))) {	
		alert("숫자만 가능합니다.");		
		obj.value = "";			
	}
	var str    = "" + obj.value.replace(/,/gi,''); // 콤마 제거 

	var regx    = new RegExp(/(-?\d+)(\d{3})/); 
	var bExists = str.indexOf(".",0); 
	var strArr  = str.split('.'); 
	while(regx.test(strArr[0]))
	{ 
		strArr[0] = strArr[0].replace(regx,"$1,$2"); 
	} 
	if (bExists > -1) 
		obj.value = strArr[0] + "." + strArr[1]; 
	else 
		obj.value = strArr[0]; 
} 

export function addCommas(val) {
	
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

